<template>
  <div>
    <iframe v-if="hash" style="width: 100%; height: 80vh"
            :src="`https://map.assistance10.com/showmanage?d=${divisionId}&h=${hash}&ch=${+(chiefRunner ?? 0)}&a=${noAction ?? 0}`"
            frameborder="0"></iframe>
  </div>
</template>

<script>

import moment from "moment";
import CryptoJS from "crypto-js";

export default {
  props: ['divisionId', 'noAction', 'chiefRunner'],
  data() {
    return {
      hash: null,
    }
  },
  mounted() {
    this.hash = this.generateKey();
    // console.log(this.divisionId, this.hash);
    // setInterval(() => {
    //   console.log(window.allObjects);
    // }, 1000)
  },
  methods: {
    generateKey() {
      return CryptoJS.AES.encrypt(JSON.stringify({
        id: this.$currentUID, time: moment().format('YYYY-MM-DD HH:mm')
      }), 'secretMapOrders').toString();
    }
  }
}

</script>
